import React from 'react';
import classNames from 'classnames';

import { UserReviewSkeleton } from '@components/UserReview/UserReviewSkeleton';

import s from './UserReviewsFeed.sss';

interface Props {
  className?: string,
  count: number,
}

export const UserReviewsFeedSkeleton: React.FC<Props> = ({
  className,
  count,
}) => (
  <ul className={classNames(
    s.list,
    className,
  )}
  >
    {[...Array(count)].map((_, i) => (
      <li
        key={i}
        className={s.review}
      >
        <UserReviewSkeleton />
      </li>
    ))}
  </ul>
);
